import React from 'react';
import { Flame, Package } from 'lucide-react';
export function UrgencyBar() {
  return <div className="bg-alphaGold text-black text-center py-1.5 sm:py-2.5 px-3 sm:px-5 text-[0.75rem] sm:text-[0.85rem] font-bold tracking-wider sticky top-0 z-[1000]" data-id="element-512" data-mp="3cvfv5iaztynf">
      <div className="max-w-[1100px] mx-auto flex items-center justify-center gap-2 sm:gap-3 flex-wrap" data-id="element-513" data-mp="37y63dw04tawf">
        <span className="flex sm:hidden items-center gap-1.5" data-id="element-514" data-mp="32zcpi2gxnhvq">
          <Flame className="w-3.5 h-3.5" data-id="element-515" data-mp="2ywy8lnwtqs73" />
          20% OFF
          <span className="text-black/50 mx-1" data-id="element-516" data-mp="2u454n296jnw2">·</span>
          <Package className="w-3.5 h-3.5" data-id="element-517" data-mp="2u3dggchwwsft" />
          Envíos desde $190
        </span>
        <span className="hidden sm:flex items-center gap-1.5" data-id="element-518" data-mp="2p63j8aoa7chf">
          <Flame className="w-4 h-4" data-id="element-519" data-mp="2k7a64jcwpnhs" />
          OFERTA ESPECIAL: 20% OFF EN TODOS LOS PRODUCTOS
        </span>
        <span className="hidden sm:inline text-black/50" data-id="element-520" data-mp="2f6coq8zq0xhc">|</span>
        <span className="hidden sm:inline" data-id="element-521" data-mp="2b5sx1kxx2m2l">
          TIEMPO LIMITADO · Solo hasta agotar stock
        </span>
        <span className="hidden sm:inline text-black/50" data-id="element-522" data-mp="1rwsormo3w51r">|</span>
        <span className="hidden sm:flex items-center gap-1.5" data-id="element-523" data-mp="1rv7uly5peo4f">
          <Package className="w-4 h-4" data-id="element-524" data-mp="1wosvpz2lfy7u" />
          Envíos desde $190 UY
        </span>
      </div>
    </div>;
}